/**
 * Каталог освещения: бра на стену, люстра, споты и плафон на потолок.
 *
 * Раздел свой, но кормит слой электрики: светильники — концы кабелей и члены
 * групп освещения, вместе с розетками и выключателями. Id элементов — ключи ссылок
 * из слоя и реестра символов, менять нельзя без миграции сохранённых проектов.
 */
import { LayerKind } from "@/shared/plan/layerKind";
import { CatalogAttach, type CatalogSection } from "../../types";
import type { LightingCatalogItem } from "./types";

export const lightingSection: CatalogSection<LightingCatalogItem> = {
	kind: LayerKind.Electrical,
	label: "Освещение",
	canChangeDimensions: false,
	subGroups: ["Свет"],
	items: [
		{
			id: "sconce",
			subGroup: "Свет",
			name: "Вывод под бра",
			description: "Точка для бра или настенного светильника на высоте 1800 мм.",
			width: 100,
			height: 100,
			depth: 16,
			elevation: 1800,
			color: "#a16207",
			attach: CatalogAttach.OnlyWall,
			lightSource: { enable: false },
			view3d: { type: "cylinder", radius: 12, height: 16, color: "#a16207" },
		},
		{
			id: "chandelier",
			subGroup: "Свет",
			name: "Люстра",
			description:
				"Люстра-кластер: латунное кольцо и восемь шаров из опалового стекла. Ставится на потолок кликом по плану.",
			width: 600,
			height: 600,
			depth: 400,
			elevation: 2700,
			color: "#a16207",
			attach: CatalogAttach.Ceiling,
			lightSource: { enable: true, color: "#ffd8a8", power: 200, distance: 6, decay: 2 },
			view3d: {
				type: "component",
				id: "chandelier-cluster",
				width: 650,
				height: 650,
				depth: 650,
				color: "#c9a45c",
			},
		},
		{
			id: "spot",
			subGroup: "Свет",
			name: "Точечный светильник",
			description:
				"Встраиваемый спот в потолке. Несколько спотов на один выключатель — одна группа.",
			width: 90,
			height: 90,
			depth: 10,
			elevation: 2700,
			color: "#a16207",
			attach: CatalogAttach.Ceiling,
			lightSource: { enable: true, color: "#fff2dc", power: 200, distance: 3, decay: 2 },
			view3d: {
				type: "component",
				id: "spot-recessed",
				width: 90,
				height: 20,
				depth: 90,
				color: "#e5e7eb",
			},
		},
		{
			id: "ceiling-lamp",
			subGroup: "Свет",
			name: "Потолочный светильник",
			description: "Накладной плафон на потолке — коридоры, санузлы, кухни.",
			width: 300,
			height: 300,
			depth: 80,
			elevation: 2700,
			color: "#a16207",
			attach: CatalogAttach.Ceiling,
			lightSource: { enable: true, color: "#ffe6b8", power: 180, distance: 5, decay: 2 },
			view3d: {
				type: "component",
				id: "ceiling-plafond",
				width: 300,
				height: 80,
				depth: 300,
				color: "#e5e7eb",
			},
		},
		{
			id: "pendant",
			subGroup: "Свет",
			name: "Светильник подвесной",
			description:
				"Подвес ⌀ 420 с плафоном на шнуре, опускается на 600 мм — над обеденным столом или островом.",
			width: 420,
			height: 420,
			depth: 600,
			elevation: 2700,
			color: "#a16207",
			attach: CatalogAttach.Ceiling,
			lightSource: { enable: true, color: "#ffe2b0", power: 180, distance: 5, decay: 2 },
			view3d: {
				type: "model",
				url: "/models/lighting/pendant.glb",
				width: 420,
				height: 600,
				depth: 420,
				color: "#a0a182",
			},
		},
	],
};
